import { Switch, Route } from "wouter";
import { queryClient } from "./lib/queryClient";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import NotFound from "@/pages/not-found";
import Home from "@/pages/home";
import Privacy from "@/pages/privacy";
import Check from "@/pages/check";
import AdminResearch from "@/pages/admin-research";
import AdminMarketing from "@/pages/admin-marketing";
import AdminClubs from "@/pages/admin-clubs";
import AdminReport from "@/pages/admin-report";
import Blog from "@/pages/blog";
import BlogPost from "@/pages/blog-post";

function Router() {
  return (
    <Switch>
      <Route path="/" component={Home} />
      <Route path="/privacy" component={Privacy} />
      <Route path="/check" component={Check} />
      <Route path="/admin/research" component={AdminResearch} />
      <Route path="/admin/marketing" component={AdminMarketing} />
      <Route path="/admin/clubs" component={AdminClubs} />
      <Route path="/admin/report" component={AdminReport} />
      <Route path="/blog" component={Blog} />
      <Route path="/blog/:slug" component={BlogPost} />
      <Route component={NotFound} />
    </Switch>
  );
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Router />
      </TooltipProvider>
    </QueryClientProvider>
  );
}

export default App;
